import { useRef } from "react";
import "@/App.css";
import "@/index.css";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import TrustedGroups from "@/components/TrustedGroups";
import BrandPlate from "@/components/BrandPlate";
import WhyBoards from "@/components/WhyBoards";
import Competencies from "@/components/Competencies";
import CommitteeFit from "@/components/CommitteeFit";
import ExpertConsulting from "@/components/ExpertConsulting";
import EngagementModel from "@/components/EngagementModel";
import Timeline from "@/components/Timeline";
import Achievements from "@/components/Achievements";
import PullQuote from "@/components/PullQuote";
import Perspectives from "@/components/Perspectives";
import Testimonials from "@/components/Testimonials";
import Manifesto from "@/components/Manifesto";
import EducationCerts from "@/components/EducationCerts";
import Certificates from "@/components/Certificates";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import SeoHead from "@/seo/SeoHead";
import seoPages from "@/seo/pages.json";
import SeoLandingPage from "@/pages/SeoLandingPage";
import InsightsPage from "@/pages/InsightsPage";
import ArticlePage from "@/pages/ArticlePage";
import NotFound from "@/pages/NotFound";

function HomePage() {
  const contactRef = useRef(null);

  const scrollToContact = () => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div id="top" className="grain relative bg-ink text-ivory min-h-screen">
      <SeoHead pathname="/" />
      <Nav />
      <main>
        <Hero onContactClick={scrollToContact} />
        <Marquee />
        <About />
        <TrustedGroups />
        <BrandPlate />
        <WhyBoards />
        <Competencies />
        <CommitteeFit />
        <ExpertConsulting />
        <EngagementModel />
        <Timeline />
        <Achievements />
        <PullQuote />
        <Testimonials />
        <Perspectives />
        <Manifesto />
        <EducationCerts />
        <Certificates />
        <Contact ref={contactRef} />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#152438",
            border: "1px solid #1E3046",
            color: "#F5F1E8",
            borderRadius: 0,
            fontFamily: "Inter, sans-serif",
          },
        }}
      />
    </div>
  );
}

function normalizePath(pathname) {
  if (!pathname || pathname === "/") return "/";
  return pathname.replace(/\/+$/, "");
}

function App() {
  const pathname = normalizePath(window.location.pathname);

  if (pathname === "/") return <HomePage />;
  if (pathname === "/insights") return <InsightsPage articles={seoPages.articles} />;
  if (seoPages.services[pathname]) {
    return <SeoLandingPage page={seoPages.services[pathname]} pathname={pathname} />;
  }
  if (seoPages.articles[pathname]) {
    return <ArticlePage page={seoPages.articles[pathname]} pathname={pathname} />;
  }
  return <NotFound pathname={pathname} />;
}

export default App;
